<script lang="ts">
  import {project} from '@/store';
  import {onDestroy} from 'svelte';

  let active: string = '';

  function changeOverlay(overlay: string) {
    removeOverlay();
    if (overlay == active) {
      active = '';
      return false;
    }
    createOverlay();
    let dom = document.querySelector<HTMLDivElement>('#safeZoneOverlay');
    if (dom) dom.className = overlay;
    active = overlay;
  }

  function removeOverlay() {
    const overlay = document.querySelector('#safeZoneOverlay');
    overlay?.remove();
  }

  function createOverlay() {
    const overlay = document.createElement('div');
    const finalImage = document.querySelector('#finalImageToExport');
    const rects = finalImage?.getBoundingClientRect();
    if (!rects || !finalImage) return;
    overlay.id = 'safeZoneOverlay';
    Object.assign(overlay.style, {
      width: rects.width + 'px',
      height: rects.height + 'px',
      backgroundSize: 'cover',
      position: 'absolute',
      top: rects.top + 'px',
      left: rects.left + 'px',
      zIndex: '1000000',
      pointerEvents: 'none',
      opacity: '0.75'
    });
    document.body.appendChild(overlay);
  }

  onDestroy(() => removeOverlay());
</script>

<div class="mb-1 flex items-center rounded-md">
  <div class="block" id="ai-camera-crew-div">
    <span class="text-sm font-bold">Preview On</span>
  </div>
  <div class="ml-auto flex gap-3">
    <button
      on:click={() => changeOverlay('fb')}
      class="{active === 'fb'
        ? 'border-rose-500'
        : 'border-zinc-200'} rounded-lg border bg-zinc-100 px-3 py-2 hover:bg-zinc-300"
    >
      <i class="fa-brands fa-facebook" />
    </button>
    <button
      on:click={() => changeOverlay('ig')}
      class="{active === 'ig'
        ? 'border-rose-500'
        : 'border-zinc-200'} rounded-lg border bg-zinc-100 px-3 py-2 hover:bg-zinc-300"
    >
      <i class="fa fa-instagram" />
    </button>
    <button
      on:click={() => changeOverlay('yt')}
      class="{active === 'yt'
        ? 'border-rose-500'
        : 'border-zinc-200'} rounded-lg border bg-zinc-100 px-3 py-2 hover:bg-zinc-300"
    >
      <i class="fa fa-youtube" />
    </button>
    <button
      on:click={() => changeOverlay('tt')}
      class="{active === 'tt'
        ? 'border-rose-500'
        : 'border-zinc-200'} rounded-lg border bg-zinc-100 px-3 py-2 hover:bg-zinc-300"
    >
      <i class="fa-brands fa-tiktok" />
    </button>
  </div>
</div>
